<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <div class="md-layout center-content">
            <!-- Form Section -->
            <div
              class="md-layout-item md-size-50 md-small-size-100 text-align-center"
            >
              <md-field class="input-width-60-center">
                <p class="validate">*</p>
                <label>اسم المجموعة</label>
                <md-input
                  v-model="groupName"
                  type="text"
                  :disabled="isLoading"
                  @keyup.enter="saveUserGroup"
                ></md-input>
              </md-field>
              <div class="mt-25 center-content gap-5">
                <md-button class="md-success" @click="saveUserGroup">
                  حفظ
                </md-button>

                <md-button
                  class="md-info"
                  @click="resetForm"
                  :disabled="isLoading"
                >
                  جديد
                </md-button>
              </div>
            </div>

            <!-- Table Section -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-progress-bar
                v-if="isLoading"
                md-mode="indeterminate"
              ></md-progress-bar>
              <md-table :value="tableData" class="table-striped table-hover">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="اسم المجموعة">
                    {{ item.name }}
                  </md-table-cell>
                  <md-table-cell md-label="الإجراءات">
                    <md-button
                      class="md-just-icon md-warning md-simple"
                      :disabled="isLoading"
                      @click="handleEditUserGroup(item)"
                    >
                      <md-icon>dvr</md-icon>
                    </md-button>
                    <md-button
                      class="md-just-icon md-danger md-simple"
                      :disabled="isLoading"
                      @click="handleDeleteUserGroup(item)"
                    >
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserGroups",

  computed: {
    tableData() {
      return this.$store.getters["permissions/getUserGroups"];
    },
    isLoading() {
      return this.$store.getters["permissions/getIsLoading"];
    },
    groupName: {
      get() {
        return this.$store.getters["permissions/getForm"].name;
      },
      set(value) {
        this.$store.dispatch("permissions/setFormName", value);
      },
    },
    isEditing() {
      return this.$store.getters["permissions/isEditing"];
    },
    isFormValid() {
      return this.$store.getters["permissions/isFormValid"];
    },
  },

  methods: {
    async saveUserGroup() {
      if (!this.isFormValid) {
        this.showWarning("من فضلك ادخل اسم المجموعة");
        return;
      }

      try {
        const result = this.isEditing
          ? await this.$store.dispatch("permissions/updateUserGroup")
          : await this.$store.dispatch("permissions/createUserGroup");

        if (result.success) {
          this.showSuccess(result.message);
        }
      } catch (error) {
        this.showError(error.message);
      }
    },

    async handleEditUserGroup(item) {
      try {
        await this.$store.dispatch("permissions/editUserGroup", item);
      } catch (error) {
        this.showError(error.message);
      }
    },

    async handleDeleteUserGroup(item) {
      try {
        const result = await this.$store.dispatch(
          "permissions/deleteUserGroup",
          item
        );
        if (result.success) {
          this.showSuccess(result.message);
        }
      } catch (error) {
        this.showError(error.message);
      }
    },

    resetForm() {
      this.$store.dispatch("permissions/resetForm");
    },

    // Notification Methods
    showSuccess(message) {
      this.notify("success", message);
    },

    showError(message) {
      this.notify("danger", message);
    },

    showWarning(message) {
      this.notify("warning", message);
    },

    notify(type, message) {
      this.$notify({
        timeout: 5000,
        message,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gap-5 {
  gap: 15px;
}
</style>
